<ng-container *ngFor="let field of card.fields; let fieldIndex = index">
  <cu-dynamic-field [page]="page" [card]="card" [field]="field" [pageSubmitted$]="pageSubmitted$"
    [fieldIndex]="fieldIndex" *ngIf="field.visible"></cu-dynamic-field>
</ng-container>